import React, { useState } from 'react';
import { observer } from 'mobx-react';

const { v4: uuid } = require('uuid');

import setVhVw from '../helpers/setVhVw';
import Header from '../components/Header/Header';

import { Props } from './_app';
import classes from './index.module.scss';

import { Provider, useStorage } from '@/models/Storage';
import { SectionIntro } from '@/components/Sections/SectionIntro/SectionIntro';
import { SectionContent } from '@/components/Sections/SectionContent/SectionContent';
import { StoryPopup } from '@/components/StoryPopup/StoryPopup';
import { PublicPath } from '@/utils/constant';

export default observer<React.FC<Props>>(function Home() {
    const storage = useStorage();

    const [likes, setLikes] = useState(undefined);

    const loadLikes = async () => {
        fetch(`${PublicPath}/api/getLikes`, {
            method: 'POST',
            body: JSON.stringify({ puid: localStorage.getItem('mskhpuid') }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.likes) {
                    setLikes(data.likes);
                }
            });
    };

    const loadUserLikes = async () => {
        fetch(`${PublicPath}/api/getUserLikes`, {
            method: 'POST',
            body: JSON.stringify({ puid: localStorage.getItem('mskhpuid') }),
        })
            .then((response) => response.json())
            .then((data) => {
                storage.setUserLikes(data || []);
            });
    };

    React.useEffect(() => {
        document.documentElement.setAttribute('data-theme', storage.darkMode ? 'dark' : 'light');
    }, [storage.darkMode]);

    React.useEffect(() => {
        document.querySelector('html').style.overflowY = storage.activeStory ? 'hidden' : 'auto';
    }, [storage.activeStory]);

    React.useEffect(() => {
        const listener = () => {
            setVhVw(window);
        };

        if (localStorage.getItem('mskhpuid')) {
            loadUserLikes().then();
        } else {
            localStorage.setItem('mskhpuid', uuid());
            loadUserLikes().then();
        }
        loadLikes().then();

        listener();
        window.addEventListener('resize', () => {
            listener();
        });
        return window.removeEventListener('resize', () => {
            listener();
        });
    }, []);

    React.useEffect(() => {
        loadLikes().then();
    }, [storage.userLikes.length]);

    return (
        <>
            <Provider value={storage}>
                <main className={classes.main}>
                    <Header />
                    <div className={classes.content}>
                        <SectionIntro />
                        <SectionContent likes={likes} />
                        {storage.activeStory && (
                            <StoryPopup
                                key={storage.activeStory}
                                likes={likes ? likes[storage.activeStory] : 0}
                            />
                        )}
                    </div>
                    <footer>
                        <div className={'container'}>Реклама ПАО&nbsp;«Газпром нефть»</div>
                    </footer>
                </main>
            </Provider>
        </>
    );
});
